<template>
  <div id="app">
    <router-view v-wechat-title="($route.meta && $route.meta.title) || '湖南省药师协会'" />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
      console.log('App.vue')
  }
}
</script>

<style>

body {
  min-width:1200px;
}
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike,
strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody,
tfoot, thead, tr, th, td ,textarea,input { margin:0; padding:0;  }
address,cite,dfn,em,var, i {font-style:normal;}
body {font-size: 16px; line-height: 1.5; font-family:'Microsoft Yahei','simsun','arial','tahoma';  color: #222; }
table { border-collapse:collapse; border-spacing:0; }
h1, h2, h3, h4, h5, h6, th { font-size: 100%; font-weight: normal; }
button,input,select,textarea{font-size:100%;}
fieldset,img{border:0;}
a { text-decoration: none; color: #666; background: none }
ul, ol { list-style: none; }
:focus{ outline:none;}
.clearfix{ clear: both; content: ""; display: block; overflow: hidden }
.clear{clear: both;}
.fl{ float: left; }
.fr{float: right;}
.textCut {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;   
}
form {
  display:block;
}
#app {

}
/***公共样式 */
.con{
  width: 1200px;
  margin: auto;
}
.clear{
  width: 100%;
  height: 0;
  clear: both;
}

.page .el-pager li{
  color: #999999;
  font-size: 16px;
  margin:0 10px;
    border: 1px solid #979797;
}
/* .el-pager li.active+li{
  border:1px solid #979797;
} */



.my-page,.my-page body
,.my-page body > section
,.my-page body #app
,.my-page body #app > section
,.my-page body #app > section
{
    width: 100%;
    height: 100%;
}
.my-page body{
    background: #fff;
}
.my-page body #app > section .el-header{
    padding: 0;
    height: auto!important;
}
.flex{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.p0{
    padding: 0!important;
}


.blueGradient {
  background-image:-webkit-linear-gradient(left,#4BB7FC,rgb(31, 132, 255));
  background-image:-o-linear-gradient(left,#4BB7FC,rgb(31, 132, 255));
  background-image:-ms-linear-gradient(left,#4BB7FC,rgb(31, 132, 255));
  background-image:linear-gradient(left,#4BB7FC,rgb(31, 132, 255));
  color:#fff;
}


</style>



// WEBPACK FOOTER //
// src/App.vue